import React from 'react';
import { SizeType } from 'antd/lib/config-provider/SizeContext';

export type FormSizeType = SizeType | 'xLarge';
export const FormContext = React.createContext<
  Partial<{ size: FormSizeType; horizontal: boolean }>
>({});
